import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
        Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch, Checkbox, IconButton, CircularProgress, Divider,
        FormControlLabel} from '@material-ui/core/'
import {Calendar, DatePicker} from '@material-ui/pickers';   
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddIcon from '@material-ui/icons/Add';
import {authFetch, logout} from '../../auth';

import DoneIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import DehazeIcon from '@material-ui/icons/Dehaze';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AssessmentIcon from '@material-ui/icons/Assessment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { TrainRounded } from '@material-ui/icons';
import { set, sub } from 'date-fns';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import RateReviewIcon from '@material-ui/icons/RateReview';
import MultilineChartIcon from '@material-ui/icons/MultilineChart';
import { use } from 'react';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3
    },
    body: {
      fontSize: 14,
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    darkText: {
        color: theme.palette.primary.main
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    componentTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        padding: 2,
        borderRadius: 10,
        marginBottom: theme.spacing(1)
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    formRow: {
        width: "100%",       
        maxHeight: "50%",        
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
        marginLeft: theme.spacing(1)
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formItem: {
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: 'normal',
        color: theme.palette.primary.dark
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    },
    searchButton:{
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.secondary.main,
        borderRadius: 8,
        fontSize: 29,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,            
        },                
    },
  }));
  
export default function Summary(props) {
    const classes = useStyles();
    var actualDate = new Date() 
    const [offerDialog, setOfferDialog] = useState(false) 
    const [feedbackDialog, setFeedbackDialog] = useState(false) 
    const [feedbackMsg, setFeedbackMsg] = useState("")
    const [clientOffers, setClientOffers] = useState([])
    const [clientName, setClientName] = useState("")
    const [clientOffer, setClientOffer] = useState({})
    const [clientCode, setClientCode] = useState("")
    const [sicCode, setSicCode] = useState("")
    const [noRegUsers, setNoRegUsers] = useState([])
    
    const [isLoading, setIsLoading] = useState(false)

    const [portfoliosInfo, setPortfoliosInfo] = useState([])
    const [portfolios, setPortfolios] = useState([])
    const [subportfolios, setSubportfolios] = useState({})
    const [selectedSubportfolio, setSelectedSubportfolio] = useState({})
    // Parametrizacion de contrato que dependen del año
    const [selectedYear, setSelectedYear] = useState('');
    // Parametrizacion de contrato que dependen de codigo
    const [contractCode, setContractCode] = useState('');
    const [tempValues, setTempValues] = useState({ g_base_value: 0, ind_base_value: 0 });
    const isReadyToAdd = contractCode.trim() !== '' && tempValues.g_base_value > 0 && tempValues.ind_base_value > 0;
    const [commonOffers, setCommonOffers] = useState({});

    const obtenerRangoDeAnios = (inicio, fin) => {
        const anioInicio = typeof(inicio) === 'string' ? new Date(inicio) : inicio.getFullYear();
        const anioFin = typeof(fin) === 'string' ? new Date(fin) : fin.getFullYear();
        const anios = [];

        for (let i = anioInicio; i <= anioFin; i++) {
            anios.push(i);
        }

        return anios;
    };

    const handleAddContract = () => {
        setClientOffer(prev => ({
            ...prev,
            g_calc_details: {
                ...prev.g_calc_details,
                [contractCode]: { ...tempValues }
            }
        }));
        // Resetear para el siguiente ciclo
        setContractCode('');
        setTempValues({ g_base_value: 0, ind_base_value: 0 });
    };

    const handleOfferDialogOpen = () => {
        setOfferDialog(true);
      };
    
    const handleOfferDialogClose = () => {
        setOfferDialog(false);
    };

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialog(true);
      };
    
    const handleFeedbackDialogClose = () => {
        setFeedbackDialog(false);
    };

    function esBisiesto(anio) {
        return (anio % 4 === 0 && anio % 100 !== 0) || (anio % 400 === 0);
    }
 
    const handleOfferUpload = () => {        
        ////console.log(contractNumber, seller, detail, market, calcType, baseValue, indexedValue, actualIpp, baseIpp, initialDate, endDate, active)
        let validationFlag = true
        if (Object.keys(selectedSubportfolio).length === 0){
            handleFeedbackDialogOpen()
            setFeedbackMsg("Por favor seleccione un subportafolio asociado a este contrato.") 
            validationFlag = false
            return
        }
        if ( !clientOffer.indexation_var || !clientOffer.indexation_base_value ||  !clientOffer.c_base_value){            
            handleFeedbackDialogOpen()
            setFeedbackMsg("Por favor ingrese los datos de indexación para el cargo C") 
            validationFlag = false
            return
        }   
        // if (clientOffer.g_calc_type && clientOffer.g_calc_type[0] === '1' && clientOffer.g_calc_details.g_base_value === 0){
        //     handleFeedbackDialogOpen()
        //     setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
        //     validationFlag = false
        // }
        // if (clientOffer.g_calc_type && clientOffer.g_calc_type[0] === '2' && clientOffer.g_calc_details.k_base_value === 0){
        //     handleFeedbackDialogOpen()
        //     setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
        //     validationFlag = false
        // }
        // if (clientOffer.g_calc_type && clientOffer.g_calc_type[0] === '3' && 
        //     (clientOffer.g_calc_details.g_base_value === 0 || clientOffer.g_calc_details.k_base_value === 0 || 
        //     clientOffer.g_calc_details.op1_perc === 0 || clientOffer.g_calc_details.op2_perc === 0)){
        //     handleFeedbackDialogOpen()
        //     setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
        //     validationFlag = false
        // }
        if (clientOffer.g_calc_type && selectedSubportfolio.g_calc_key === "GENER_DEM_COT_PC_DEM_COT_PB"){
            // Validar todos los inputs posibles de techos e indexacion para todos los años
            let years = obtenerRangoDeAnios(clientOffer.start_date, clientOffer.finish_date)
            for (let year of years){
                let isBissexto = esBisiesto(year)
                if (!clientOffer.g_calc_details[year]?.ind_base_value){
                    handleFeedbackDialogOpen()
                    // Feedback con las variables de interes
                    setFeedbackMsg(`El valor base de indexación para ${clientOffer.g_calc_details.g_indexation_var} del año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
                if (!clientOffer.g_calc_details[year]?.g_base_value){
                    handleFeedbackDialogOpen()
                    setFeedbackMsg(`El valor base de cargo G para el año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
                if (!clientOffer.g_calc_details[year]?.hour_limit_30_days){
                    handleFeedbackDialogOpen()
                    setFeedbackMsg(`El techo de 30 días para el año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
                if (!clientOffer.g_calc_details[year]?.hour_limit_31_days){
                    handleFeedbackDialogOpen()
                    setFeedbackMsg(`El techo de 31 días para el año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
                if (!isBissexto && !clientOffer.g_calc_details[year]?.hour_limit_28_days){
                    handleFeedbackDialogOpen()
                    setFeedbackMsg(`El techo de 28 días para el año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
                else if (isBissexto && !clientOffer.g_calc_details[year]?.hour_limit_29_days){
                    handleFeedbackDialogOpen()
                    setFeedbackMsg(`El techo de 29 días para el año ${year} no puede estar vacío.`)
                    validationFlag = false
                    return
                }
            }
        }
        else if (clientOffer.g_calc_type && selectedSubportfolio.g_calc_key === "GENER_MUL_CTO"){
            // Validar que al menos exista una llave de contrato dentro de g_calc_details
            if (Object.keys(clientOffer.g_calc_details).length === 1){
                handleFeedbackDialogOpen()
                setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
                validationFlag = false
            }
        }
        if (validationFlag) {                                                       
            authFetch(
                "/api/update-no-reg-offers",
                {
                  method: 'post',
                  body: JSON.stringify(clientOffer),
                }
              ).then(r => {
              if (r.status === 422){
                logout()
                return null
              }
              else{
                return r.json()
              }
            })
                .then(response => {
                  if (response.Upload === 'OK'){
                    setFeedbackMsg('Oferta guardada.')
                    handleFeedbackDialogOpen()        
                    handleOfferDialogClose() 
                    checkUserOffer(clientCode)               
                  }
                  else {
                    setFeedbackMsg('Error al guardar los datos.')
                    handleFeedbackDialogOpen()
                  }
                })
        }
    }

    
 

    const checkUserOffer = (clientCode) => {
        authFetch("/api/check-no-reg-offers?username=" + String(props.username) + '&client_code=' + clientCode).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.offers){
                    if (!response.client_name){
                        setFeedbackMsg('No se encontró cliente para el código proporcionado.')
                        handleFeedbackDialogOpen()
                        setClientName("")
                    }
                    else if (response.offers.length === 0){
                        setClientName(response.client_name)
                        setSicCode(response.sic_code)
                        setFeedbackMsg('Cliente sin contrato. Haga click en AGREGAR para ingresar los datos correspondientes.')                        
                        handleFeedbackDialogOpen()
                    }
                    else if (response.offers.length > 0){
                        setSicCode(response.sic_code)
                        setClientName(response.client_name)
                        setClientOffers(response.offers)
                        let offer = response.offers[0]
                        offer.start_date = new Date(offer.start_date)
                        offer.finish_date = new Date(offer.finish_date)
                        setClientOffer(offer)
                    }
                }
            })
    }

    const showFeedbackDialog = () => (
        <Dialog
            open={feedbackDialog}
            onClose={handleFeedbackDialogClose}       
            className={classes.formText}            
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>Aviso</DialogTitle>
        <DialogContent className={classes.dialogContent}>
            <DialogContentText>
                {feedbackMsg}
            </DialogContentText>
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>
            Aceptar
          </Button>
        </DialogActions>
        </Dialog>
    )
 
    const showOfferDialog = () => (
        <Dialog
            open={offerDialog}
            onClose={handleOfferDialogClose}       
            className={classes.formText}
            scroll={'paper'}
            maxWidth={'md'}
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>{"Ingrese los datos correspondientes del contrato."}</DialogTitle>
        <DialogContent className={classes.dialogContent}>                     
            <Grid container spacing={1} alignItems="flex-start" justify="space-evenly">                
                <Grid item xs={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Cliente:</Typography>
                        </Grid>
                        <Grid item>
                            <BusinessCenterIcon/>
                        </Grid>                
                        <Grid item xs={9}>                   
                            <TextField
                                value={clientName}                               
                                InputProps={{
                                    readOnly: true,
                                    className: classes.formDefined,
                                    classes: {                                        
                                        input: classes.formText
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}   
                                disabled                                                           
                            />
                        </Grid> 
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Código SIC:</Typography>
                        </Grid>
                        <Grid item>
                            <LocationCityIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField                                
                                value={sicCode}                                
                                InputProps={{
                                    readOnly: true,
                                    className: classes.formDefined,
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}    
                                disabled                                                      
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Detalle:</Typography>
                        </Grid>
                        <Grid item>
                            <DehazeIcon/>
                        </Grid>               
                        <Grid item xs={9}>
                            <TextField
                                value={clientOffer.detail}                             
                                placeholder={"Detalle de la oferta."}
                                InputProps={{                                   
                                    classes: {                                        
                                        input: classes.formText
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow} 
                                multiline                                       
                                onChange={(e) => {setClientOffer({...clientOffer, detail: e.target.value});}}                       
                            />
                                
                        </Grid>   
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Fecha de suscripción:</Typography>                    
                        </Grid>                        
                        <Grid item >
                            <DateRangeIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <DatePicker    
                                variant="dialog"    
                                inputVariant="standard"                                                                                 
                                okLabel={""}
                                cancelLabel={""}                            
                                format="dd-MMMM-yyyy"
                                //minDate={new Date(`${selectedYear1.getFullYear()}-01-02`)}
                                //maxDate={new Date(`${selectedYear1.getFullYear()}-12-31`)}                                                                                    
                                value={clientOffer.suscription_date}
                                InputLabelProps={{                                            
                                            classes: {
                                                root: classes.labelText,                                    
                                            }
                                        }}
                                onChange={(date) => {setClientOffer({...clientOffer, suscription_date: date});}}
                                error={false}
                                InputProps={{                                            
                                            classes: {
                                                input: classes.formText,                                    
                                            }
                                        }}
                            
                                autoOk                                                                                  
                            /> 
                        </Grid>                                                                                                                    
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Fecha de inicio:</Typography>                    
                        </Grid>                        
                        <Grid item >
                            <DateRangeIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <DatePicker    
                                variant="dialog"    
                                inputVariant="standard"                                                                                 
                                okLabel={""}
                                cancelLabel={""}                            
                                format="dd-MMMM-yyyy"
                                //minDate={new Date(`${selectedYear1.getFullYear()}-01-02`)}
                                //maxDate={new Date(`${selectedYear1.getFullYear()}-12-31`)}                                                    
                                value={clientOffer.start_date}
                                InputLabelProps={{                                            
                                            classes: {
                                                root: classes.labelText,                                    
                                            }
                                        }}
                                onChange={(date) => {setClientOffer({...clientOffer, start_date: date});}}
                                error={false}
                                InputProps={{                                            
                                            classes: {
                                                input: classes.formText,                                    
                                            }
                                        }}
                            
                                autoOk                                                                                  
                            /> 
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Fecha de terminación:</Typography>                    
                        </Grid>                        
                        <Grid item >
                            <DateRangeIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <DatePicker    
                                variant="dialog"    
                                inputVariant="standard"                                                                                 
                                okLabel={""}
                                cancelLabel={""}                            
                                format="dd-MMMM-yyyy"
                                //minDate={new Date(`${selectedYear1.getFullYear()}-01-02`)}
                                //maxDate={new Date(`${selectedYear1.getFullYear()}-12-31`)}                                                        
                                value={clientOffer.finish_date}
                                InputLabelProps={{                                            
                                            classes: {
                                                root: classes.labelText,                                    
                                            }
                                        }}
                                onChange={(date) => {setClientOffer({...clientOffer, finish_date: date});}}
                                error={false}
                                InputProps={{                                            
                                            classes: {
                                                input: classes.formText,                                    
                                            }
                                        }}
                            
                                autoOk                                                                                  
                            /> 
                        </Grid>
                        <Grid item>
                            <Grid container justify="flex-start" style={{marginTop: 10}}>
                                <Grid item>
                                <Typography variant="body2" color="primary" style={{marginLeft: 10}}>{clientOffer.active? 'Activo':'Inactivo'}</Typography>
                                </Grid>
                                <Grid item xs={12}></Grid>
                                <Grid item>
                                <Switch
                                    checked={clientOffer.active}
                                    onChange={(e) => {setClientOffer({...clientOffer, active: e.target.checked});}}
                                    color="primary"                                                 
                                />
                                </Grid>                                                        
                            </Grid>
                        </Grid>
                        
                    </Grid>                                       
                </Grid>     
                <Grid item xs={8}>                    
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="subtitle2" align="left">Portafolios:</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle2" align="left">Subportafolio:</Typography>
                        </Grid>
                        <Grid item>
                            <LocalMallIcon/>
                        </Grid>
                        <Grid item xs={5}>                   
                            <TextField
                                value={clientOffer.portfolio} 
                                placeholder={"Seleccione el portafolio."}                               
                                InputProps={{                                    
                                    classes: {
                                        input: classes.formText,                                       
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}                                                                                         
                                select
                                onChange = {(e) => {setClientOffer({...clientOffer, portfolio: e.target.value});
                                                    }}
                            >
                                {
                                    portfolios.length > 0 ? 
                                    portfolios.map((portfolio, idx) => (
                                        <MenuItem key={idx+portfolio} value={portfolio} classes={classes.formItem}>{portfolio}</MenuItem>
                                    ))
                                    :
                                    []
                                }
                            </TextField>
                                                    
                        </Grid>
                        <Grid item>
                            <RateReviewIcon/>
                        </Grid>
                        <Grid item xs={5}>                   
                            <TextField
                                value={clientOffer.subportfolio || ''}
                                placeholder={"Seleccione el subportafolio."}
                                InputProps={{                                    
                                    classes: {
                                        input: classes.formText,                                       
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}                                                                                         
                                select
                                onChange = {(e) => {
                                    setClientOffer({...clientOffer, subportfolio: e.target.value});
                                    let selectedSubportfolio = portfoliosInfo.find(portfolio => portfolio.name === clientOffer.portfolio && portfolio.subportfolio_name === e.target.value)
                                    setSelectedSubportfolio(selectedSubportfolio)
                                    if (selectedSubportfolio.subportfolio_name in commonOffers){
                                        let newOffer = commonOffers[selectedSubportfolio.subportfolio_name]
                                        newOffer["subportfolio"] = e.target.value
                                        newOffer = {...clientOffer, ...newOffer}
                                        setClientOffer(newOffer)
                                    }
                                }}
                            >
                                {
                                    subportfolios[clientOffer.portfolio] ? 
                                    subportfolios[clientOffer.portfolio].map((subportfolio, idx) => (
                                        <MenuItem key={idx+subportfolio} value={subportfolio} classes={classes.formItem}>{subportfolio}</MenuItem>
                                    ))
                                    :
                                    []
                                }
                            </TextField>
                                                    
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Metodología cargo C:
                                <Typography variant='body1'>{' '}{clientOffer.c_calc_type ? clientOffer.c_calc_type : ''}</Typography>
                            </Typography>
                        </Grid>
                        {
                            clientOffer.c_calc_type ?
                            <>
                            <Grid container item xs={4} spacing={2}>
                                
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" align="left">Variable de indexación:</Typography>
                                </Grid>
                                <Grid item>
                                    <MoreVertIcon/>
                                </Grid>
                                <Grid item xs={9}>                   
                                    <TextField
                                        value={clientOffer.indexation_var}                               
                                        InputProps={{
                                            readOnly: true,
                                            className: classes.formDefined,
                                            classes: {                                        
                                                input: classes.formText
                                            }
                                        }}
                                        variant="standard"
                                        className={classes.formRow}   
                                        disabled                                                           
                                    />                                                    
                                </Grid>
                            </Grid>
                                                    
                            
                            {
                                clientOffer.indexation_var ? 
                                <Grid container item xs={4} spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">{'Valor base ' + clientOffer.indexation_var + ':'}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <ShowChartIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.indexation_base_value}
                                            placeholder={"Ingrese el valor base del " + clientOffer.indexation_var}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {setClientOffer({...clientOffer, indexation_base_value: e.target.value});}}                            
                                        />                           
                                    </Grid>
                                </Grid> 
                                :
                                null
                            }
                            
                            <Grid container item xs={4} spacing={1}>            
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" align="left">Valor base componente C:</Typography>
                                </Grid>
                                <Grid item>
                                    <MonetizationOnIcon/>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        type="number"
                                        value={clientOffer.c_base_value}
                                        placeholder={"Ingrese el valor de C."}
                                        InputProps={{                                    
                                            classes: {
                                                input: classes.formText
                                            }
                                        }}
                                        variant="standard"
                                        className={classes.formRow}   
                                        onChange={(e) => {setClientOffer({...clientOffer, c_base_value: e.target.value});}}                            
                                    />                           
                                </Grid>                         
                            </Grid>
                            </>
                            :   
                            null
                        }
                        {/* PANEL G */}
                        <Grid item xs={12}>
                            <Divider color="primary" variant="middle" style={{marginTop: 10, marginBottom: 10}}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Metodología cargo G:
                                <Typography variant='body1'>{' '}{clientOffer.g_calc_type ? clientOffer.g_calc_type : ''}</Typography>
                            </Typography>
                        </Grid>
                           
                        {
                            clientOffer.g_calc_type ?
                                // TODO En caso de adoptar mas usuarios regulados no solo ecopetrol las indexaciones ahora deben manejarse por separado para C y G luego
                                // hay que actualizar el formulario con los 3 primeros metodos
                                selectedSubportfolio.g_calc_key === "GENER_PF" ? 
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">Valor base componente G:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <MonetizationOnIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'g_base_value' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.g_base_value : 0}
                                            placeholder={"Ingrese el valor base de G."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, g_base_value: e.target.value}})
                                            }}                            
                                        />                           
                                    </Grid> 
                                </Fragment>
                                :
                                selectedSubportfolio.g_calc_key === "GENER_PB_K" ? 
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">Valor base K:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <MonetizationOnIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'k_base_value' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.k_base_value : 0}
                                            placeholder={"Ingrese el valor K."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, k_base_value: e.target.value}})
                                            }}                             
                                        />                           
                                    </Grid> 
                                </Fragment>
                                :
                                selectedSubportfolio.g_calc_key === "GENER_PERC_PF_PERC_PB_K" ? 
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">Valor base componente G:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <MonetizationOnIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'g_base_value' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.g_base_value : null}
                                            placeholder={"Ingrese el valor base de G."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, g_base_value: e.target.value}})
                                            }}                            
                                        />                           
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">Valor base K:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <MonetizationOnIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'k_base_value' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.k_base_value : 0}
                                            placeholder={"Ingrese el valor K."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, k_base_value: e.target.value}})
                                            }}                             
                                        />                           
                                    </Grid> 
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">% Opción 1:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <FiberManualRecordIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'op1_perc' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.op1_perc : 0}
                                            placeholder={"Ingrese el % de la opción 1."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, op1_perc: e.target.value}})
                                            }}                             
                                        />                           
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">% Opción 2:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <FiberManualRecordIcon/>
                                    </Grid>
                                    <Grid item xs={9}>
                                    <TextField
                                            type="number"
                                            value={clientOffer.g_calc_details && 'op2_perc' in clientOffer.g_calc_details ? 
                                                clientOffer.g_calc_details.op2_perc : 0}
                                            placeholder={"Ingrese el % de la opción 2."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard"
                                            className={classes.formRow}   
                                            onChange={(e) => {
                                                let gCalcDetails = clientOffer.g_calc_details
                                                setClientOffer({...clientOffer, g_calc_details: {...gCalcDetails, op2_perc: e.target.value}})
                                            }}                             
                                        />                          
                                    </Grid>
                                </Fragment>
                                :
                                selectedSubportfolio.g_calc_key === "GENER_DEM_COT_PC_DEM_COT_PB" ?
                                <>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" align="left">Año:</Typography>
                                    </Grid>
                                    <Grid item>
                                        <DateRangeIcon/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            select
                                            value={selectedYear}
                                            variant="standard"
                                            className={classes.formRow}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            onChange={(e) => setSelectedYear(e.target.value)}
                                            >
                                            {
                                                clientOffer.start_date && clientOffer.finish_date ?
                                                obtenerRangoDeAnios(clientOffer.start_date, clientOffer.finish_date).map((year) => (
                                                <MenuItem key={year} value={year}>{year}</MenuItem>
                                                ))
                                                :
                                                []
                                            }
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}/>
                                    <Grid container item xs={6} spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Techo horario mes 28 días (MWh):</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MultilineChartIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            disabled={!selectedYear} // No editar si no hay año seleccionado
                                            value={
                                                clientOffer.g_calc_details?.[selectedYear]?.hour_limit_28_days || 0
                                            }
                                            variant="standard"
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setClientOffer(prev => ({
                                                ...prev,
                                                g_calc_details: {
                                                    ...prev.g_calc_details,
                                                    [selectedYear]: {
                                                    ...prev.g_calc_details?.[selectedYear],
                                                    hour_limit_28_days: newValue
                                                    }
                                                }
                                                }));
                                            }}
                                        />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Techo horario mes 29 días (MWh):</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MultilineChartIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            disabled={!selectedYear} // No editar si no hay año seleccionado
                                            value={
                                                clientOffer.g_calc_details?.[selectedYear]?.hour_limit_29_days || 0
                                            }
                                            variant="standard"
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setClientOffer(prev => ({
                                                ...prev,
                                                g_calc_details: {
                                                    ...prev.g_calc_details,
                                                    [selectedYear]: {
                                                    ...prev.g_calc_details?.[selectedYear],
                                                    hour_limit_29_days: newValue
                                                    }
                                                }
                                                }));
                                            }}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={6} spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Techo horario mes 30 días (MWh):</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MultilineChartIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            disabled={!selectedYear} // No editar si no hay año seleccionado
                                            value={
                                                clientOffer.g_calc_details?.[selectedYear]?.hour_limit_30_days || 0
                                            }
                                            variant="standard"
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setClientOffer(prev => ({
                                                ...prev,
                                                g_calc_details: {
                                                    ...prev.g_calc_details,
                                                    [selectedYear]: {
                                                    ...prev.g_calc_details?.[selectedYear],
                                                    hour_limit_30_days: newValue
                                                    }
                                                }
                                                }));
                                            }}
                                        />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Techo horario mes 31 días (MWh):</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MultilineChartIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            disabled={!selectedYear} // No editar si no hay año seleccionado
                                            value={
                                                clientOffer.g_calc_details?.[selectedYear]?.hour_limit_31_days || 0
                                            }
                                            variant="standard"
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setClientOffer(prev => ({
                                                ...prev,
                                                g_calc_details: {
                                                    ...prev.g_calc_details,
                                                    [selectedYear]: {
                                                    ...prev.g_calc_details?.[selectedYear],
                                                    hour_limit_31_days: newValue
                                                    }
                                                }
                                                }));
                                            }}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={4} spacing={2}>                                    
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Variable de indexación:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MoreVertIcon/>
                                        </Grid>
                                        <Grid item xs={9}>                   
                                            <TextField
                                                value={clientOffer.g_calc_details.g_indexation_var}                               
                                                InputProps={{
                                                    readOnly: true,
                                                    className: classes.formDefined,
                                                    classes: {                                        
                                                        input: classes.formText
                                                    }
                                                }}
                                                variant="standard"
                                                className={classes.formRow}   
                                                disabled                                                           
                                            />                                                    
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={4} spacing={2}>                                    
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">{'Valor base ' + clientOffer.g_calc_details.g_indexation_var + ':'}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <ShowChartIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField
                                                type="number"
                                                disabled={!selectedYear} // No editar si no hay año seleccionado
                                                value={
                                                    clientOffer.g_calc_details?.[selectedYear]?.ind_base_value || 0
                                                }
                                                variant="standard"
                                                className={classes.formRow}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.formText
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setClientOffer(prev => ({
                                                    ...prev,
                                                    g_calc_details: {
                                                        ...prev.g_calc_details,
                                                        [selectedYear]: {
                                                        ...prev.g_calc_details?.[selectedYear],
                                                        ind_base_value: newValue
                                                        }
                                                    }
                                                    }));
                                                }}
                                            />                           
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={4} spacing={2}>  
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" align="left">Valor base cargo G:</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MonetizationOnIcon/>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField
                                                type="number"
                                                disabled={!selectedYear} // No editar si no hay año seleccionado
                                                value={
                                                    clientOffer.g_calc_details?.[selectedYear]?.g_base_value || 0
                                                }
                                                variant="standard"
                                                className={classes.formRow}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.formText
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setClientOffer(prev => ({
                                                    ...prev,
                                                    g_calc_details: {
                                                        ...prev.g_calc_details,
                                                        [selectedYear]: {
                                                        ...prev.g_calc_details?.[selectedYear],
                                                        g_base_value: newValue
                                                        }
                                                    }
                                                    }));
                                                }}
                                            />                           
                                        </Grid>
                                    </Grid>
                                </>
                                :
                                selectedSubportfolio.g_calc_key === "GENER_MUL_CTO" ?
                                <>

                                {
                                    Object.entries(clientOffer.g_calc_details || {}).map(([code, data]) => (
                                    code !== 'g_indexation_var' ?
                                    <Grid container spacing={2} key={code} style={{ opacity: 0.7, marginBottom: 10, marginLeft: 10 }}>
                                        <Grid item xs={3}><TextField label="Código SIC"  InputProps={{
                                                    readOnly: true,
                                                    className: classes.formDefined,
                                                    classes: {                                        
                                                        input: classes.formText
                                                    }
                                                }} value={code} variant="standard" /></Grid>
                                        <Grid item xs={3}><TextField label={"Valor Base " + clientOffer.g_calc_details.g_indexation_var}  InputProps={{
                                                    readOnly: true,
                                                    className: classes.formDefined,
                                                    classes: {                                        
                                                        input: classes.formText
                                                    }
                                                }} value={data.ind_base_value} variant="standard" /></Grid>
                                        <Grid item xs={3}><TextField label="Valor Base G"  InputProps={{
                                                    readOnly: true,
                                                    className: classes.formDefined,
                                                    classes: {                                        
                                                        input: classes.formText
                                                    }
                                                }} value={data.g_base_value} variant="standard" /></Grid>
                                        <Grid item xs={3}><TextField label="Despacho Horario"  InputProps={{
                                                    readOnly: true,
                                                    className: classes.formDefined,
                                                    classes: {                                        
                                                        input: classes.formText
                                                    }
                                                }} value={data.hourly_energy_delivery} variant="standard" /></Grid>
                                    </Grid>
                                    :
                                    null
                                ))}
                                
                                <Divider style={{ margin: '20px 0' }} />

                                {/* --- CICLO DE EDICIÓN ACTUAL (DRAFT) --- */}
                                {/* Código del Contrato */}
                                <Grid container item xs={4} spacing={2}>
                                    <Grid item xs={12}><Typography variant="subtitle2">Código SIC:</Typography></Grid>
                                    <Grid item><MonetizationOnIcon/></Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard" 
                                            value={contractCode} 
                                            onChange={(e) => setContractCode(e.target.value)} 
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={8}></Grid>

                                {/* Variable de Indexación */}
                                <Grid container item xs={4} spacing={2}>
                                    <Grid item xs={12}><Typography variant="subtitle2">Variable de Indexación:</Typography></Grid>
                                    <Grid item><MoreVertIcon/></Grid>
                                    <Grid item xs={8}>
                                        <TextField variant="standard" 
                                        InputProps={{
                                                readOnly: true,
                                                className: classes.formDefined,
                                                classes: {                                        
                                                    input: classes.formText
                                                }
                                            }}
                                        value={clientOffer.g_calc_details.g_indexation_var} disabled />
                                    </Grid>
                                </Grid>

                                {/* Valor Base Variable */}
                                <Grid container item xs={4} spacing={2}>
                                    <Grid item xs={12}><Typography variant="subtitle2">Valor Base {clientOffer.g_calc_details.g_indexation_var}:</Typography></Grid>
                                    <Grid item><ShowChartIcon/></Grid>
                                    <Grid item xs={8}>
                                        <TextField
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            type="number" 
                                            variant="standard" 
                                            disabled={!contractCode} // Se habilita si hay código
                                            value={tempValues.ind_base_value}
                                            onChange={(e) => setTempValues({...tempValues, ind_base_value: e.target.value})}
                                        />
                                    </Grid>
                                </Grid>

                                {/* Valor Base Cargo G */}
                                <Grid container item xs={4} spacing={1}>
                                    <Grid item xs={12}><Typography variant="subtitle2">Valor base componente G:</Typography></Grid>
                                    <Grid item><MonetizationOnIcon/></Grid>
                                    <Grid item xs={8}>
                                        <TextField 
                                            type="number"
                                            className={classes.formRow}
                                            InputProps={{
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard" 
                                            disabled={!contractCode} // Se habilita si hay código
                                            value={tempValues.g_base_value}
                                            onChange={(e) => setTempValues({...tempValues, g_base_value: e.target.value})}
                                        />
                                    </Grid>
                                </Grid>

                                {/* Despacho Horario */}
                                <Grid container item xs={4} spacing={1}>
                                    <Grid item xs={12}><Typography variant="subtitle2">Despacho Horario:</Typography></Grid>
                                    <Grid item><ShowChartIcon/></Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            type="number"
                                            value={tempValues.hourly_energy_delivery}
                                            placeholder={"Ingrese el despacho horario."}
                                            InputProps={{                                    
                                                classes: {
                                                    input: classes.formText
                                                }
                                            }}
                                            variant="standard" 
                                            disabled={!contractCode} // Se habilita si hay código
                                            onChange={(e) => setTempValues({...tempValues, hourly_energy_delivery: e.target.value})}
                                        />
                                    </Grid>
                                </Grid>
                                
                                {/* <Grid container item xs={6}>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox 
                                                name="ejemplo" 
                                                color="primary" 
                                                defaultChecked // Para que aparezca marcado por defecto (fake data)
                                                />
                                            }
                                            label="Aplicar a todas las fronteras del Portafolio"
                                        />
                                    </Grid>
                                </Grid> */}

                                {/* Botón Guardar / Agregar */}
                                <Grid container item xs={12} justify="space-evenly">
                                <Grid item>
                                    <Fab
                                        color="secondary"
                                        size="small"
                                        variant="extended"
                                        disabled={!isReadyToAdd} // Habilitado solo si todo tiene valor
                                        onClick={handleAddContract}
                                        style={{ marginTop: 25}}

                                    >
                                        <AddIcon style={{ marginRight: 8 }} />
                                        {' Guardar'}
                                    </Fab>
                                </Grid>
                                </Grid>
                                </>
                                :
                                null
                            :
                            null
                        }                                                                                                                                                                                                                                                                                                                                                                                    
                    </Grid>                                       
                </Grid>
                               
                <Grid item style={{marginTop: 20}}>
                    <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleOfferUpload}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><SaveIcon /> {' Guardar  '}</Fragment>                         
                    </Fab>
                </Grid>                   
                <Grid item style={{marginTop: 20}}>
                    <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleOfferDialogClose}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><CancelIcon /> {'Cancelar'}</Fragment>                         
                    </Fab>
                </Grid>
            </Grid>            
        </DialogContent>        
        </Dialog>
    )

    const downloadOffers = () => {
        setIsLoading(true)
        authFetch("/api/download-no-reg-offers"+ "?timestamp=" + new Date().toISOString().slice(0,19)
            +"&username=" + String(props.username),
            { responseType: 'blob' } 
        ).then(response => {
          setIsLoading(false) 
          if (response.status === 422){
              logout()
          }
          else if (response.status === 200){
            return response.blob()
          } 
          }).then(blob => {                              
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'Ofertas_NR_'+props.username+'.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);                                               
        })
    }

    useEffect (() => {
        document.title ="Contratos usuarios no regulados";
        authFetch("/api/check-portfolios-list?username=" + props.username
            + "&with_details="+ true
        ).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.portfolios){
                    setPortfoliosInfo(response.portfolios)
                    let portfolioNames = response.portfolios.map((portfolio) => portfolio.name)                    
                    setPortfolios(Array.from(new Set(portfolioNames)))
                    let subportfolioObj = {}
                    response.portfolios.forEach(portfolio => {
                        if (subportfolioObj[portfolio.name] === undefined) subportfolioObj[portfolio.name] = []
                        subportfolioObj[portfolio.name].push(portfolio.subportfolio_name)
                    })
                    setSubportfolios(subportfolioObj)
                    let offer = response.common_offers
                    offer.start_date = new Date(offer.start_date)
                    offer.finish_date = new Date(offer.finish_date)
                    offer.suscription_date = new Date(offer.suscription_date)
                    setCommonOffers(offer)
                }
            })

        authFetch("/api/check-clients?username=" + String(props.username)+                                                  
                                                          "&year=null" +"&billing=true"
                        + "&user_type=" + props.userType).then(response => {
                    if (response.status === 422){
                            logout()
                            return null
                        }
                        return response.json()
                    }).then(response => {
                        if (response && response.clients){
                            let noRegUsers = response.clients.map(client => 
                                client.client_code + " - " + client.sic_code + " - " + client.client_name)
                            setNoRegUsers(noRegUsers)
                        }
                    }) 
    }, [])

    useEffect (() => {
        if (clientOffer.portfolio === undefined || !clientOffer.subportfolio){
            setClientOffer(prev => ({...prev, c_calc_type: '', g_calc_type: ''}))
            return            
        }
        let selectedSubportfolio = portfoliosInfo.find(portfolio => portfolio.name === clientOffer.portfolio && portfolio.subportfolio_name === clientOffer.subportfolio)
        setClientOffer(prev => ({...prev, c_calc_type: selectedSubportfolio.c_calc_name}))
        setClientOffer(prev => ({...prev, g_calc_type: selectedSubportfolio.g_calc_name}))
        setClientOffer(prev => ({
            ...prev,
            indexation_var: selectedSubportfolio.c_indexation_var
        }));
        setClientOffer(prev => ({
            ...prev,
            g_calc_details: {
            ...prev.g_calc_details,
                g_indexation_var: selectedSubportfolio.g_indexation_var
        }
        }));
        setSelectedSubportfolio(selectedSubportfolio)
        // At DB indexation_var is for C

    }, [clientOffer.subportfolio])

    useEffect (() => {
        setClientOffer(prev => ({...prev, c_calc_type: '', g_calc_type: '', subportfolio: ""}))
        setSelectedSubportfolio({})
    }, [clientOffer.portfolio])

    useEffect(() => {
        if (clientOffer.portfolio && clientOffer.subportfolio && portfoliosInfo.length > 0) {
            const sub = portfoliosInfo.find(p => 
                p.name === clientOffer.portfolio && 
                p.subportfolio_name === clientOffer.subportfolio
            );
            if (sub) {
                setSelectedSubportfolio(sub);
            }
        }
    }, [clientOffer.portfolio, clientOffer.subportfolio, portfoliosInfo]);

    return (
        <div className={classes.root}>
            {showOfferDialog()}
            {showFeedbackDialog()}
            <Zoom in timeout={800}>
            {   
                <Grid container justify="space-evenly">                

                    <Grid item xs={12} style={{marginTop: 5}}>                    
                        <Grid container justify="center" spacing={1} alignItems="center">
                            <Grid item xs={11}>
                            <Typography variant="subtitle1" className={classes.sectionTitle}>Contrato por cliente</Typography>
                            </Grid>
                            <Grid item xs={11}>
                                <Typography variant="subtitle2" align="center" color="primary">Seleccionar cliente</Typography>
                            </Grid> 
                            <Grid item xs={4}>
                                <Autocomplete
                                    options={noRegUsers}
                                    getOptionLabel={(option) => option}
                                    onChange={(event, newValue) => {
                                        if (newValue != null) {
                                            setClientCode(newValue.split(" - ")[0]);
                                            setClientName('');
                                            setClientOffers([]);
                                        }
                                    }}
                                    renderInput={(params) => {
                                        const { InputProps, ...restParams } = params;

                                        return (
                                        <TextField
                                            {...restParams}
                                            variant="outlined"
                                            size="small"
                                            className={classes.formRow}
                                            InputProps={{
                                            ...InputProps,
                                            classes: {
                                                input: classes.formText
                                            }
                                            }}
                                        />
                                        );
                                    }}
                                />
                            </Grid>
                            {/* <Grid item xs={3}>
                                <TextField 
                                    variant="outlined" 
                                    size="small"
                                    InputProps={{
                                        classes: {
                                            input: classes.formText
                                        }
                                    }}
                                    className={classes.formRow} 
                                    value={clientCode}
                                    onChange={(e) => {setClientCode(e.target.value); setClientName(''); setClientOffers([]);}}
                                >
                                </TextField>
                            </Grid> */}
                            
                            <Grid item>
                                <IconButton color="primary" onClick={(e) => {checkUserOffer(clientCode)}}>
                                    <SearchOutlinedIcon className={classes.searchButton} />
                                    <Typography variant="subtitle2" align="center" color="primary" style={{marginLeft: 5}}>Buscar</Typography>
                                </IconButton>                             
                            </Grid>
                            
                            <Grid item xs={12}></Grid>
                        
                            <Grid item xs={11}>
                            <TableContainer component={Paper} style={{marginTop: 10}}>
                                <Table aria-label="markets table">
                                    <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" style={{width: "7%"}}>Código SIC</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "7%"}}>Código Cliente</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "13%"}}>Nombre</StyledTableCell>                                
                                        <StyledTableCell align="center" style={{width: "7%"}}>Valor base C</StyledTableCell>                           
                                        <StyledTableCell align="center" style={{width: "5%"}}>Indexación C</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "9%"}}>Indexación base C</StyledTableCell>                               
                                        <StyledTableCell align="center" style={{width: "15%"}}>Tipo de Cálculo G</StyledTableCell>                                                                   
                                        <StyledTableCell align="center" style={{width: "10%"}}>Fecha inicial</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "10%"}}>Fecha final</StyledTableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>    
                                        {
                                            clientOffers.map( (offer, idx) => (
                                                    <TableRow onClick={(e) => {handleOfferDialogOpen(); setClientOffer(offer);}}>
                                                        <StyledTableCell align="center">{sicCode ? sicCode : '-'}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.client_code ?  offer.client_code : clientCode}</StyledTableCell>
                                                        <StyledTableCell align="center">{clientName}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.c_base_value ? offer.c_base_value : '-'}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.indexation_var ? offer.indexation_var : '-'}</StyledTableCell> 
                                                        <StyledTableCell align="center">{offer.indexation_base_value ? offer.indexation_base_value : '-'}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.g_calc_type ? offer.g_calc_type : '-'}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.start_date ? new Date(offer.start_date).toLocaleString('en-GB', {day: "2-digit", month: "2-digit", year: "numeric"}) : '-'}</StyledTableCell>
                                                        <StyledTableCell align="center">{offer.finish_date ? new Date(offer.finish_date).toLocaleString('en-GB', {day: "2-digit", month: "2-digit", year: "numeric"}) : '-'}</StyledTableCell>                                                                                                                    
                                                    </TableRow>
                                            )) 
                                        }                                                                                                                  
                                    </TableBody>
                                </Table>
                            </TableContainer> 
                            </Grid>
                            <Grid item xs={3}>                    
                                {
                                clientName !== '' ?
                                <Fab
                                    color="primary"
                                    size="small"
                                    component="span"
                                    aria-label="add"
                                    variant="extended"                        
                                    classes={{root: classes.uploadButton}}
                                    onClick={() => {
                                        let clientOffersArray = clientOffers;
                                        clientOffersArray.push({active: true, client_code: clientCode, username: props.username, start_date: new Date(), finish_date: new Date()});
                                        setClientOffers([...clientOffersArray]);                                                                                        
                                    }}     
                                    style={{marginTop: 15}}                           
                                > 
                                    <Fragment><AddIcon /> {' Agregar  '}</Fragment>                         
                                </Fab> 
                                :
                                null
                                }                     
                            </Grid>
                        </Grid>
                    </Grid> 
                    <Grid item xs={12} style={{marginTop: 30}}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Descargar contratos</Typography>
                        <Grid container justify="center">
                        <Grid item xs={6}>                        
                            {
                                isLoading ? 
                                <CircularProgress/>
                                :
                                <Fab
                                    color="primary"
                                    size="small"
                                    component="span"
                                    aria-label="add"
                                    variant="extended"                        
                                    classes={{root: classes.uploadButton}}
                                    onClick={downloadOffers}
                                    style={{marginTop: 20}}
                                > 
                                    <Fragment><ArrowDropDownCircleIcon /> {'Descargar'}</Fragment>                         
                                </Fab>
                            }                           
                        </Grid>
                        </Grid>
                    </Grid>
                                                                                               
                </Grid>
            }
            </Zoom>    
        </div>
    );
}